import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const getTableOrders = (company, posProfile) => {
    const params = {};
    // In single-company mode we intentionally do NOT send the company param at all.
    if (company) {
        params.company = company;
    }
    if (posProfile) {
        params.pos_profile = posProfile;
    }

    return axios.get(`method/restaurant_management.api.get_floor_data`, { params });
};

export const useGetTableOrders = ({ company, posProfile, disabled }) => {
    return useQuery(
        ["getTableOrdersData", company, posProfile],
        async () => {
            const { data } = await getTableOrders(company, posProfile);
            return data;
        },
        {
            // When company/profile changes, avoid rendering stale room map from previous scope.
            keepPreviousData: false,
            staleTime: 5 * 1000,
            cacheTime: 5 * 60 * 1000,
            refetchOnMount: false,
            refetchOnReconnect: true,
            refetchOnWindowFocus: false,
            enabled: !disabled,
        }
    );
};

export const useMoveOrderItems = () => {
    return useMutation(async ({ items, orderId, destinationTable, client }) => {
        const args = {
            items: items,
            destinationTable,
            client,
        };

        const params = {
            model: `Table Order`,
            name: orderId,
            method: `divide`,
            args: JSON.stringify(args),
        };
        const data = await axios.post(
            `method/frappe_helper.api.call`,
            params
        );

        return data;
    });
};

//move_table_orders
